module.exports = __webpack_public_path__ + "static/img/moreFunction4.f3c5624.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/moreFunction4.webp
// module id = vZFH
// module chunks = 2